/**
 * Transform order Traveler to PersonInfo
 */
export default ({
    prefix,
    name: [{firstName, lastName}],
    email,
    phone,
    citizenshipId,
    personId,
    dateOfBirth,
    passports,
    isChild,
}) => ({
    prefix,
    firstName,
    lastName,
    email,
    contactPhone: phone,
    citizenshipId,
    personId,
    birthdate: dateOfBirth,
    passports: passports.map(({expiryDate, ...passport}) => ({...passport, validTill: expiryDate})),
    type: isChild ? 'child' : 'adult',
})
